import { createAction, props } from '@ngrx/store';

import { ContactsListActionTypes } from './types';

export const init = createAction(ContactsListActionTypes.Init);

export const contactSelected = createAction(
  ContactsListActionTypes.ContactSelected,
  props<{ selectedId: string }>()
);

export const contactEnabled = createAction(
  ContactsListActionTypes.ContactEnabled,
  props<{ userId: string }>()
);

export const contactDisabled = createAction(
  ContactsListActionTypes.ContactDisabled,
  props<{ userId: string }>()
);
